export function twoLetterAvatarString(name: string): string {
  const nameComponents = name.split(' ');
  const letters =
    nameComponents.length === 1
      ? nameComponents[0].substring(0, 2)
      : `${nameComponents[0][0]}${nameComponents[1][0]}`;
  return letters.toUpperCase();
}
